import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const token = this.authService.getUserToken();

        // Ensure credentials (cookies) are sent for our API
        // Filter out known external APIs that strict CORS might block if we send creds unexpectedly
        const isExternal = request.url.endsWith('/auth/login')
            || request.url.includes('paypal.com')
            || request.url.includes('googleapis.com')
            || request.url.includes('cloudflarestorage.com')
            || request.url.includes('publichome.page')
            || request.url.includes('openstreetmap.org');

        if (!isExternal) {
            let cloneUpdate: any = {
                withCredentials: true
            };

            const hostname = window.location.hostname;
            if (hostname.startsWith('admin.')) {
                const secret = localStorage.getItem('admin-secret');
                if (secret) {
                    cloneUpdate.setHeaders = { 'X-Admin-Secret': secret };
                }
            }

            const authReq = request.clone(cloneUpdate);
            return next.handle(authReq);
        }

        return next.handle(request);
    }
}
